import React, { useEffect } from 'react';
import { injectIntl } from '../../util/reactIntl';
import { useDispatch, useSelector } from 'react-redux';
import {
  Page,
  UserNav,
  LayoutSingleColumn,
  LayoutWrapperTopbar,
  LayoutWrapperMain,
  LayoutWrapperFooter,
  Footer,
  ManageSubscriptionPanel,
  LayoutSideNavigation,
} from '../../components';
import css from './ManageSubscriptionPage.module.css';
import { withRouter } from 'react-router-dom';
import { withViewport } from '../../util/uiHelpers';
import { compose } from 'redux';
// import { checkScrollingDisabled } from './ManageSubscriptionPage.duck';
import TopbarContainer from '../TopbarContainer/TopbarContainer';
import {
  checkScrollingDisabled,
  getListing,
  getSubscriptionData,
} from '../StripeSubscriptionPage/StripeSubscriptionPage.duck';
import { searchListings } from '../SearchPage/SearchPage.duck';

export const ManageSubscriptionPage = props => {
  const { intl, location, history, viewport } = props;

  const dispatch = useDispatch();
  const isScrollingDisabled = useSelector(state => checkScrollingDisabled(state));
  const { user, StripeSubscriptionPage } = useSelector(state => state);

  const { getStatusData, fetchListing } = StripeSubscriptionPage;

  const { currentUser } = user;
  const title = intl.formatMessage({ id: 'ManageSubscriptionPage.title' });

  useEffect(() => {
    if (currentUser?.id?.uuid) {
      dispatch(getSubscriptionData());
      dispatch(getListing());
    }
  }, [currentUser]);

  const listingId = fetchListing[0]?.id?.uuid;
  const { publicData } =
    (currentUser && currentUser.attributes && currentUser.attributes.profile) || {};
  const subscriptionPlatform = publicData && publicData.subscriptionPlatform;

  return (
    <div>
      <Page className={css.root} title={title} scrollingDisabled={isScrollingDisabled}>
        <LayoutSideNavigation
          className={css.manageSubscriptionWrapper}
          topbar={
            <>
              <TopbarContainer
                currentPage="StripeSubscriptionPage"
                desktopClassName={css.desktopTopbar}
                mobileClassName={css.mobileTopbar}
              />
              <UserNav currentPage="StripeSubscriptionPage" />
            </>
          }
          sideNav={null}
          useAccountSettingsNav
          currentPage="StripeSubscriptionPage"
          // footer={<Footer />}
        >
          <div className={css.content}>
            <ManageSubscriptionPanel
              history={history}
              location={location}
              currentUser={currentUser}
              getStatusData={getStatusData}
              subscriptionPlatform={subscriptionPlatform}
              listingId={listingId}
            />
          </div>
        </LayoutSideNavigation>
      </Page>
    </div>
  );
};

export default compose(
  withViewport,
  withRouter,
  injectIntl
)(ManageSubscriptionPage);
